__webpack_require__.p = "/wp-content/plugins/tsg-co2-calculator/frontend/build/";